import fails$1 from './fails.js';

var fails = fails$1; // check the existence of a method, lowercase
// of a tag and escaping quotes in arguments

var stringHtmlForced = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

export { stringHtmlForced as default };
